export default {
  SET_PARTNERS(state, payload) {
    state.AllPartners = payload;
  },
  SET_SELECTED_PARTNERS_FOR_UPDATE(state, payload) {
    state.selectedPartnersForUpdate = payload;
  },
};
